import React from 'react';
import styles from '../styles/DecisionTool.styles';
import SegmentPreferenceIndex from './SegmentPreferenceIndex';
import SegmentInfo from './SegmentInformation';
import { useState, useEffect } from 'react';

const ResearchDevelopmentTable = ({
    attributesList,
    manufacturedBikeValues,
    rdUpgrades,
    upgradedBikeValues,
    handleUpgradeChange,
    budget,
    roundNumber,
}) => {
    const [showSegmentPreference, setShowSegmentPreference] = useState(false);
    const [showSegmentInfo, setShowSegmentInfo] = useState(false);
    const [totalRndCost, setTotalRndCost] = useState(0); // total R&D cost state
    const [isRndError, setIsRndError] = useState(false); // error handling state for R&D

    const toggleSegmentPreference = () => {
        setShowSegmentPreference((prev) => !prev);
    };

    const toggleSegmentInfo = () => {
        setShowSegmentInfo((prev) => !prev);
    };

    useEffect(() => {
        // Get the total R&D cost by summing the values of the rdUpgrades object
        const totalCost = Object.values(rdUpgrades).reduce((sum, cost) => sum + cost, 0);

        // Determine the budget based on the current round number
        const maxBudget = roundNumber === 3 ? 2000000 : 1500000;

        // Update the total R&D cost and check for error if it exceeds the max budget
        const totalRndCost = totalCost * 500000;
        setTotalRndCost(totalRndCost);

        // Check if the total R&D cost exceeds the max budget
        setIsRndError(totalRndCost > maxBudget);

    }, [rdUpgrades, roundNumber]); // This effect runs whenever rdUpgrades or roundNumber changes

    return (
        <div>
            <div className={styles.headerContainer}>
                <h2>Research and Development</h2>
                <button onClick={toggleSegmentPreference} className={styles.toggleButton} style={{ marginBottom: '10px' }} >
                    {showSegmentPreference ? 'Hide Population size and Preference Overview' : 'View Population size and Preference Overview'}
                </button>
                <button onClick={toggleSegmentInfo} className={styles.toggleButton} style={{ marginBottom: '10px', marginLeft: '5px' }} >
                    {showSegmentInfo ? 'Hide Advertising Cost by Audience' : 'View Advertising Cost by Audience'}
                </button>
            </div>

            {
                showSegmentPreference && (
                    <div className={styles.collapsibleSection}>
                        <SegmentPreferenceIndex />
                    </div>
                )
            }
            {
                showSegmentInfo && (
                    <div className={styles.collapsibleSection}>
                        <SegmentInfo />
                    </div>
                )
            }
            <p> Make improvements to your manufactured bike. 1pt = $500k. </p>
            <table className={styles.tradeoffTable}>
                <thead>
                    <tr>
                        <styles.att2>Attribute</styles.att2>
                        {attributesList.map((columnAttribute) => (
                            <styles.th key={columnAttribute}>{columnAttribute}</styles.th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <styles.field2>Manufactured Bike</styles.field2>
                        {attributesList.map((columnAttribute) => (
                            <styles.td key={columnAttribute}>{manufacturedBikeValues[columnAttribute]}</styles.td>
                        ))}
                    </tr>

                    <tr>
                        <styles.field2>R&D Upgrades</styles.field2>
                        {attributesList.map((columnAttribute) => (
                            <styles.td key={columnAttribute}>
                                <select
                                    value={rdUpgrades[columnAttribute] * 500000}
                                    onChange={(e) => handleUpgradeChange(columnAttribute, parseFloat(e.target.value))}
                                >
                                    {[0, 500000, 1000000, 1500000, 2000000].map((value, index) => (
                                        <option key={index} value={value}>
                                            ${value.toLocaleString()}
                                        </option>
                                    ))}
                                </select>
                            </styles.td>
                        ))}
                    </tr>

                    <tr>
                        <styles.field2>Final Bike</styles.field2>
                        {attributesList.map((columnAttribute) => (
                            <styles.td key={columnAttribute}>{upgradedBikeValues[columnAttribute]}</styles.td>
                        ))}
                    </tr>
                </tbody>
            </table>

            <p></p>

            <div className={styles.totalContainer}>
                <styles.label>TOTAL R&D COST :</styles.label>
                <styles.sumInput
                    type="text"
                    value={`$${totalRndCost.toLocaleString()}`}
                    readOnly
                    style={{
                        color: isRndError ? 'red' : 'darkgreen',
                        width: '120px',  // Adjust the width as needed
                        fontSize: '16px', // Increase font size if needed
                        padding: '5px', // Add padding for better spacing
                    }}
                />
                {isRndError && (
                    <span style={{ color: 'red', marginLeft: '10px' }}>
                        ERROR: R&D Budget Exceeded
                    </span>
                )}
            </div>


            <div>
                <p></p>
            </div>
        </div >
    );
};

export default ResearchDevelopmentTable;